import React from 'react';
import classNames from 'classnames';

const SectionHeading = ({ className, size = 'md', children, ...rest }) => {

  if (size === 'sm') {
    return (
      <>
        <div className={classNames('h6 mb-0 p-1', className)} {...rest}>
          {children}
        </div>
        <hr className="mt-0 mb-1" />
      </>
    );
  }

  return (
    <>
      <div className={classNames('h5 mb-0 mt-2 p-1', className)} {...rest}>
        {children}
      </div>
      <hr className="mt-0 mb-2" />
    </>
  );
};

export default SectionHeading;

